<template>
  <v-layout align-start>
    <v-flex>
      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll flat>
          <v-toolbar-title class="font-weight-black"
            >Solicitud de Personal</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              :loading="load"
              @click="exportarExcel"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> fa-solid fa-file-excel </v-icon>
            </v-btn>
          </template>
          <span>Exportar a Excel</span>
        </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="addItem"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> add </v-icon>
              </v-btn>
            </template>
            <span>Nueva Solicitud de Personal</span>
          </v-tooltip>
        </v-app-bar>
      </v-card>
      <v-data-table
        dense
        :headers="headersPersona"
        :items="personas"
        :search="search"
        sort-by="calories"
        class="elevation-1"
        :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-text': 'Filas por página',
          'items-per-page-options': [50, 100, 150, -1],
        }"
      >
        <template v-slot:[`item.opciones`]="{ item }">
          <v-btn
            x-small
            text
            dark
            color="primary"
            @click="editItemPersona(item)"
          >
            <v-icon x-small>visibility </v-icon>
          </v-btn>

          <v-btn
            :class="item.estado == 'S' ? '' : 'd-none'"
            x-small
            text
            dark
            color="primary"
            @click="mostrarDialogRechazarPersona(item)"
          >
            <v-icon x-small>block </v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <div v-if="item.estado == 'S'">
            <v-btn color="accent" x-small text dark> Solicitado </v-btn>
          </div>
          <div v-if="item.estado == 'AR'">
            <v-btn color="success" x-small text dark> Aprobado P&C </v-btn>
          </div>

          <div v-if="item.estado == 'A'">
            <v-btn color="success" x-small text dark> Aprobado Gerencia </v-btn>
          </div>
          <div v-if="item.estado == 'R'">
            <v-btn color="error" x-small text dark> Rechazado </v-btn>
          </div>
        </template>
        <template v-slot:[`item.insertDate`]="{ item }">
          <div>
            {{ $formatoFechaSpanish(item.insertDate) }}
          </div>
         
        </template>
        <template v-slot:[`item.fecha_ingreso`]="{ item }">
          <div>
            {{ $formatoFechaSpanish(item.fecha_ingreso) }}
          </div>
         
        </template>
        <template v-slot:[`item.fecha_salida`]="{ item }">
          <div>
            {{ $formatoFechaSpanish(item.fecha_salida) }}
          </div>
         
        </template>

        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>

            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="searchCodigoValue"
              append-icon="search"
              label="Codigo"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="searchCIValue"
              append-icon="search"
              label="Doc. Identidad"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="searchNombreValue"
              append-icon="search"
              label="Nombre"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>

            <v-dialog
              v-model="dialogPersona"
              persistent
              max-width="800px"
              transition="dialog-bottom-transition"
            >
              <v-card ref="formPersona">
                <v-app-bar color="white" elevate-on-scroll flat>
                  <v-card-title>
                    Formulario de Solicitud de Personal
                    <v-spacer></v-spacer>
                    <div v-if="estado == 'A'">
                      <v-chip
                        dense
                        class="ma-2"
                        color="success"
                        text-color="white"
                      >
                        Aprobada Gerencia
                      </v-chip>
                    </div>
                    <div v-else>
                      <div v-if="estado == 'AR'">
                        <v-chip
                          dense
                          class="ma-2"
                          color="success"
                          text-color="white"
                        >
                          Aprobada P&C
                        </v-chip>
                      </div>
                      <div v-else>
                        <div v-if="estado == 'R'">
                          <v-chip
                            dense
                            class="ma-2"
                            color="error"
                            text-color="white"
                          >
                            Rechazado
                          </v-chip>
                        </div>
                        <div v-else>
                          <v-chip
                            dense
                            class="ma-2"
                            color="blue"
                            text-color="white"
                          >
                            Solicitado
                          </v-chip>
                        </div>
                      </div>
                    </div>
                  </v-card-title>
                  <v-spacer></v-spacer>

                  <div v-if="(rol == 'GER') & (estado == 'AR')">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="mostrarDialogAutorizar"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> add_task </v-icon>
                        </v-btn>
                      </template>
                      <span>Autorizar personal</span>
                    </v-tooltip>
                  </div>
                  <div v-if="(rol == 'GER') & (estado == 'A')">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="mostrarDialogRevertirAut"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> restore </v-icon>
                        </v-btn>
                      </template>
                      <span>Revertir Autorización de Personal</span>
                    </v-tooltip>
                  </div>
                  <div v-if="(rol == 'NOM') & (estado == 'S') & editCodigo2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          
                          @click="mostrarDialogAprobarRH"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> task_alt </v-icon>
                        </v-btn>
                      </template>
                      <span>Aprobar Personal</span>
                    </v-tooltip>
                  </div>
                  <div v-if="(rol == 'NOM') & (estado == 'AR') & editCodigo2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="mostrarDialogRevertirRH"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> restore </v-icon>
                        </v-btn>
                      </template>
                      <span>Revertir Aprobación Personal</span>
                    </v-tooltip>
                  </div>

                  <div v-if="(rol == 'NOM') & (estado == 'S') & editCodigo2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="rechazarPersona()"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> block </v-icon>
                        </v-btn>
                      </template>
                      <span>Rechazar Solicitud </span>
                    </v-tooltip>
                  </div>
                  <div v-if="(rol == 'GER') & (estado != 'A') & editCodigo2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="rechazar()"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> block </v-icon>
                        </v-btn>
                      </template>
                      <span>Rechazar Solicitud </span>
                    </v-tooltip>
                  </div>
                  <div v-if="(rol == 'NOM') & (estado == 'R') & editCodigo2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="pendiente()"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> pending </v-icon>
                        </v-btn>
                      </template>
                      <span>Marcar como solcitado </span>
                    </v-tooltip>
                  </div>

                  <div v-if="estado == 'S' & editCodigo2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="dialogEliminarPersona = true"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Eiminar </span>
                    </v-tooltip>
                  </div>

                  <div v-if="estado == 'S'">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="guardarPersona"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> save</v-icon>
                        </v-btn>
                      </template>
                      <span>Guardar </span>
                    </v-tooltip>
                  </div>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        large
                        @click="closePersona"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark> close </v-icon>
                      </v-btn>
                    </template>
                    <span>Volver/Cancelar</span>
                  </v-tooltip>
                </v-app-bar>

                <v-card-text>
                  <v-row>
                    <v-col cols="8" sm="8" md="8">
                      <v-text-field
                        outlined
                        dense
                        ref="solicitante"
                        v-model="solicitante"
                        :readonly="true"
                        :rules="[]"
                        :error-messages="errorMessagesPersona"
                        label="Solicitante"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" md="4">
                      <v-text-field
                        outlined
                        type="date"
                        dense
                        ref="fechaSolicitud"
                        :readonly="true"
                        v-model="fechaSolicitud"
                        :rules="[]"
                        :error-messages="errorMessagesPersona"
                        label="Fecha de Solicitud"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-autocomplete
                        outlined
                        dense
                        ref="id_area"
                        v-model="id_area"
                        @change="selectSubarea"
                        :readonly="!editCodigo"
                        :items="areas"
                        :rules="[rules.requerido]"
                        :error-messages="errorMessagesPersona"
                        item-text="descripcion"
                        item-value="id"
                        label="Area Administrativa"
                        required
                      ></v-autocomplete>

                      <v-autocomplete
                        outlined
                        dense
                        ref="id_subarea"
                        v-model="id_subarea"
                        @change="selectCargo"
                        :readonly="!editCodigo"
                        :items="subareas"
                        :rules="[rules.requerido]"
                        :error-messages="errorMessagesPersona"
                        item-text="descripcion"
                        item-value="id"
                        label="Subárea Administrativa"
                        required
                      ></v-autocomplete>

                      <v-autocomplete
                        outlined
                        dense
                        ref="id_cargo"
                        v-model="id_cargo"
                        return-object
                        :items="cargos"
                        :readonly="!editCodigo"
                        :rules="[rules.requerido]"
                        @change="cargarNombre"
                        :error-messages="errorMessagesPersona"
                        item-text="descripcion"
                        item-value="id"
                        label="Cargo"
                        required
                      ></v-autocomplete>
                      <v-text-field
                        v-show="mostrarNuevoCargo"
                        outlined
                        dense
                        :readonly="!editCodigo"
                        ref="nuevo_cargo"
                        v-model="nuevo_cargo"
                        @change="cargarNombre"
                        :rules="[]"
                        :error-messages="errorMessagesPersona"
                        label="Nombre de Cargo"
                      ></v-text-field>
                      <v-autocomplete
                        outlined
                        dense
                        ref="id_grupo_nomina"
                        v-model="id_grupo_nomina"
                        @change="validarPeriodo"
                        :items="grupos"
                        :rules="[rules.requerido]"
                        :readonly="estado != 'S'"
                        :error-messages="errorMessagesPersona"
                        item-text="descripcion"
                        item-value="id"
                        label="Grupo Nómina"
                        required
                      ></v-autocomplete>

                      <v-autocomplete
                        outlined
                        dense
                        ref="id_ciudad"
                        v-model="id_ciudad"
                        :items="ciudades"
                        :rules="[rules.requerido]"
                        :error-messages="errorMessagesPersona"
                        item-text="descripcion"
                        item-value="id"
                        label="Sucursal"
                        required
                      ></v-autocomplete>

                      <v-text-field
                        outlined
                        type="date"
                        dense
                        ref="fecha_ingreso"
                        v-model="fecha_ingreso"
                        :rules="[rules.requerido]"
                        :error-messages="errorMessagesPersona"
                        :readonly="estado != 'S'"
                        label="Fecha de Ingreso"
                        required
                      ></v-text-field>
                      <div :class="esPlanilla ? 'd-none' : ''">
                        <v-text-field
                          outlined
                          type="date"
                          dense
                          ref="fecha_salida"
                          v-model="fecha_salida"
                          :rules="[]"
                          :error-messages="errorMessagesPersona"
                          :readonly="estado != 'S'"
                          label="Fecha de Salida"
                          required
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-textarea
                        outlined
                        dense
                        ref="info_adicional"
                        v-model="info_adicional"
                        :rules="[]"
                        :error-messages="errorMessagesUpload"
                        label="Información Adicional"
                        placeholder="Información Adicional"
                        required
                      ></v-textarea>
                      <v-textarea
                        outlined
                        dense
                        ref="motivo"
                        v-model="motivo"
                        :rules="[]"
                        :error-messages="errorMessagesUpload"
                        label="Motivo de Solicitud"
                        placeholder="Motivo de Solicitud"
                        required
                      ></v-textarea>

                      <v-text-field
                        outlined
                        dense
                        ref="salario_ref"
                        v-model="salario_ref"
                        :readonly="
                          !(rol === 'NOM' || rol === 'GER' || rol === 'ADM')
                        "
                        :rules="[rules.numero]"
                        :error-messages="errorMessagesPersona"
                        @change="mostrarGastos"
                        label="Haber Básico"
                        required
                        reverse
                      ></v-text-field>

                      <v-menu
                        v-model="menu"
                        top
                        right
                        transition="scale-transition"
                        origin="bottom left"
                      >
                        <template v-slot:activator="{ on }">
                          <v-chip pill v-on="on" color="primary">
                            <v-avatar left>
                              <v-icon>monetization_on</v-icon>
                            </v-avatar>
                            Costo Anual: {{ costoTotal }} Bs.
                            <v-avatar right>
                              <v-icon>add_circle</v-icon>
                            </v-avatar>
                          </v-chip>
                        </template>
                        <v-card width="500" style="overflow: auto">
                          <v-sheet class="overflow-y-auto" :max-height="400">
                            <v-treeview
                              :items="gastos"
                              style="width: max-content"
                            ></v-treeview>
                          </v-sheet>
                        </v-card>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-tabs
                  v-model="tab"
                  background-color="primary"
                  dark
                  vertical
                  :class="'d-none'"
                >
                  <v-tab>
                    <v-icon left> people </v-icon>
                    Info. Personal &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </v-tab>
                  <v-tab>
                    <v-icon left>business</v-icon>
                    Info. Laboral
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </v-tab>

                  <v-tab>
                    <v-icon left>payments</v-icon>
                    Info. de Pago
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </v-tab>
                  <v-tab>
                    <v-icon left>health_and_safety</v-icon>
                    Info. Caja de Salud
                  </v-tab>
                  <v-tab>
                    <v-icon left>accessible</v-icon>
                    Info. discapacidad &nbsp;
                  </v-tab>

                  <v-tab-item eager>
                    <v-card flat>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              outlined
                              dense
                              ref="profesion"
                              v-model="profesion"
                              :rules="[]"
                              :error-messages="errorMessagesPersona"
                              label="Profesion"
                              required
                            ></v-text-field>

                            <v-text-field
                              outlined
                              type="date"
                              dense
                              ref="fecha_ingreso_vac"
                              v-model="fecha_ingreso_vac"
                              :rules="[]"
                              :error-messages="errorMessagesPersona"
                              label="Fecha de Ingreso Vacaciones"
                              required
                            ></v-text-field>

                            <v-text-field
                              outlined
                              type="date"
                              dense
                              ref="fecha_ingreso_ant_vac"
                              v-model="fecha_ingreso_ant_vac"
                              :rules="[]"
                              :error-messages="errorMessagesPersona"
                              label="Fecha de Ingreso Antiguedad Vacaciones"
                              required
                            ></v-text-field>

                            <v-text-field
                              outlined
                              type="date"
                              dense
                              ref="fecha_ingreso_bono_ant"
                              v-model="fecha_ingreso_bono_ant"
                              :rules="[]"
                              :error-messages="errorMessagesPersona"
                              label="Fecha de Ingreso Bono Antiguedad"
                              required
                            ></v-text-field>

                            <v-text-field
                              outlined
                              dense
                              ref="telefono_3"
                              v-model="telefono_3"
                              :rules="[]"
                              :error-messages="errorMessagesPersona"
                              label="Teléfono Oficina"
                              required
                            ></v-text-field>
                            <v-text-field
                              outlined
                              dense
                              ref="email_3"
                              v-model="email_3"
                              :rules="[rules.email]"
                              :error-messages="errorMessagesPersona"
                              label="Email Oficina"
                              required
                            ></v-text-field>

                            <v-textarea
                              outlined
                              dense
                              ref="info_adicional"
                              v-model="info_adicional"
                              :rules="[]"
                              :error-messages="errorMessagesPersona"
                              label="Info. Adicional"
                              auto-grow
                              rows="1"
                              required
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            outlined
                            dense
                            ref="doc_identidad"
                            v-model="doc_identidad"
                            @keyup="mostrarCodigo"
                            :rules="[rules.requerido, rules.max30, rules.min2]"
                            :error-messages="errorMessagesPersona"
                            label="Número de documento"
                            required
                          ></v-text-field>
                          <v-autocomplete
                            outlined
                            dense
                            ref="emitido_en"
                            v-model="emitido_en"
                            :items="lugarEmision"
                            :rules="[rules.requerido]"
                            :error-messages="errorMessagesPersona"
                            label="Expedido en"
                            required
                          ></v-autocomplete>
                          <v-autocomplete
                            outlined
                            dense
                            ref="tipo_doc"
                            v-model="tipo_doc"
                            :items="tipoDocumento"
                            :rules="[rules.requerido]"
                            :error-messages="errorMessagesPersona"
                            label="Tipo Documento"
                            required
                          ></v-autocomplete>
                          <v-text-field
                            outlined
                            dense
                            ref="adic_segip"
                            v-model="adic_segip"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="Adicional SEGIP"
                            required
                          ></v-text-field>
                          <v-text-field
                            outlined
                            dense
                            ref="pasaporte"
                            v-model="pasaporte"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="Pasaporte"
                            required
                          ></v-text-field>
                          <v-text-field
                            outlined
                            type="date"
                            dense
                            ref="vence_doc"
                            v-model="vence_doc"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="Vence Documento"
                            required
                          ></v-text-field>

                          <v-autocomplete
                            outlined
                            dense
                            ref="genero"
                            v-model="genero"
                            :items="generos"
                            :rules="[rules.requerido]"
                            :error-messages="errorMessagesPersona"
                            label="Género"
                            required
                          ></v-autocomplete>

                          <v-autocomplete
                            outlined
                            dense
                            ref="estado_civil"
                            v-model="estado_civil"
                            :items="estadoCiviles"
                            :rules="[rules.requerido]"
                            :error-messages="errorMessagesPersona"
                            label="Estado Civil"
                            required
                          ></v-autocomplete>

                          <v-autocomplete
                            outlined
                            dense
                            ref="id_pais"
                            v-model="id_pais"
                            :items="paises"
                            :rules="[rules.requerido]"
                            :error-messages="errorMessagesPersona"
                            label="Pais de Nacionalidad"
                            required
                          ></v-autocomplete>

                          <v-text-field
                            outlined
                            dense
                            ref="permiso_conducir"
                            v-model="permiso_conducir"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="Número de Permiso de Conducir"
                            required
                          ></v-text-field>
                          <v-text-field
                            outlined
                            type="date"
                            dense
                            ref="vence_permiso"
                            v-model="vence_permiso"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="Vencimiento Permiso"
                            required
                          ></v-text-field>

                          <v-autocomplete
                            outlined
                            dense
                            ref="tipo_sangre"
                            v-model="tipo_sangre"
                            :items="tipoSangre"
                            :rules="[rules.requerido]"
                            :error-messages="errorMessagesPersona"
                            item-text="descripcion"
                            item-value="id"
                            label="Tipo de Sangre"
                            required
                          ></v-autocomplete>

                          <v-text-field
                            outlined
                            dense
                            ref="contacto_emer"
                            v-model="contacto_emer"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="Contacto Emergencia"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            ref="telefono_emer"
                            v-model="telefono_emer"
                            :rules="[rules.numero]"
                            :error-messages="errorMessagesPersona"
                            label="Teléfono emergencia"
                            required
                          ></v-text-field>
                          <v-text-field
                            outlined
                            dense
                            ref="direccion"
                            v-model="direccion"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="Dirección"
                            required
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            outlined
                            dense
                            ref="telefono_1"
                            v-model="telefono_1"
                            :rules="[rules.numero]"
                            :error-messages="errorMessagesPersona"
                            label="Teléfono "
                            required
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            ref="telefono_2"
                            v-model="telefono_2"
                            :rules="[rules.numero]"
                            :error-messages="errorMessagesPersona"
                            label="Celular"
                            required
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            ref="email_1"
                            v-model="email_1"
                            :rules="[rules.email]"
                            :error-messages="errorMessagesPersona"
                            label="Email Principal"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            ref="email_2"
                            v-model="email_2"
                            :rules="[rules.email]"
                            :error-messages="errorMessagesPersona"
                            label="Email alternativo"
                            required
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            ref="red_social_1"
                            v-model="red_social_1"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="Red Social 1"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            ref="red_social_2"
                            v-model="red_social_2"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="Red Social 2"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            ref="red_social_3"
                            v-model="red_social_3"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="Red Social 3"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            ref="dep_ini"
                            v-model="dep_ini"
                            :rules="[rules.numero, rules.requerido]"
                            :error-messages="errorMessagesPersona"
                            label="Dependientes Inicial "
                            required
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            ref="dep_prim"
                            v-model="dep_prim"
                            :rules="[rules.numero, rules.requerido]"
                            :error-messages="errorMessagesPersona"
                            label="Dependientes Primaria "
                            required
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            ref="dep_sec"
                            v-model="dep_sec"
                            :rules="[rules.numero, rules.requerido]"
                            :error-messages="errorMessagesPersona"
                            label="Dependientes secundaria"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-text-field
                          outlined
                          dense
                          ref="nombre_1"
                          v-model="nombre_1"
                          :keyup="mostrarNombre"
                          :rules="[rules.requerido, rules.min2, rules.max50]"
                          :error-messages="errorMessagesPersona"
                          label="Primer Nombre"
                          required
                        ></v-text-field>

                        <v-text-field
                          outlined
                          dense
                          ref="nombres_2"
                          v-model="nombres_2"
                          :keyup="mostrarNombre"
                          :rules="[]"
                          :error-messages="errorMessagesPersona"
                          label="Segundo Nombre"
                          required
                        ></v-text-field>

                        <v-text-field
                          outlined
                          dense
                          ref="nombres_3"
                          v-model="nombres_3"
                          :keyup="mostrarNombre"
                          :rules="[]"
                          :error-messages="errorMessagesPersona"
                          label="Tercer Nombre"
                          required
                        ></v-text-field>

                        <v-text-field
                          outlined
                          dense
                          ref="apellido_1"
                          v-model="apellido_1"
                          :keyup="mostrarNombre"
                          :rules="[rules.requerido, rules.min2, rules.max50]"
                          :error-messages="errorMessagesPersona"
                          label="Apellido Paterno"
                          required
                        ></v-text-field>

                        <v-text-field
                          outlined
                          dense
                          ref="apellido_2"
                          v-model="apellido_2"
                          :keyup="mostrarNombre"
                          :rules="[]"
                          :error-messages="errorMessagesPersona"
                          label="Apellido Materno"
                          required
                        ></v-text-field>

                        <v-text-field
                          outlined
                          dense
                          ref="apellido_3"
                          v-model="apellido_3"
                          :keyup="mostrarNombre"
                          :rules="[]"
                          :error-messages="errorMessagesPersona"
                          label="Apellido Casada"
                          required
                        ></v-text-field>

                        <v-text-field
                          outlined
                          type="date"
                          dense
                          ref="fecha_nac"
                          v-model="fecha_nac"
                          :rules="[rules.requerido]"
                          :error-messages="errorMessagesPersona"
                          label="Fecha de Nacimiento"
                          required
                        ></v-text-field>

                        <v-autocomplete
                          outlined
                          dense
                          ref="id_pais_nac"
                          v-model="id_pais_nac"
                          @change="selectCiudades"
                          :items="paises"
                          :rules="[rules.requerido]"
                          :error-messages="errorMessagesPersona"
                          label="Pais de Nacimiento"
                          required
                        ></v-autocomplete>

                        <v-text-field
                          outlined
                          dense
                          ref="codigo"
                          v-model="codigo"
                          :append-icon="editCodigo ? 'block' : 'edit'"
                          :readonly="!editCodigo"
                          :rules="[rules.requerido, rules.min2, rules.max30]"
                          :error-messages="errorMessagesPersona"
                          label="Código"
                          required
                          @change="editCodigo = !editCodigo"
                          @click:append="editCodigo = !editCodigo"
                        ></v-text-field>

                        <v-row align="center" justify="center">
                          <v-col cols="12" align="center" justify="center">
                            <v-avatar size="200" class="black">
                              <img :src="foto" max-height="200" contain />
                            </v-avatar>
                          </v-col>
                        </v-row>

                        <v-file-input
                          dense
                          id="file"
                          ref="file"
                          @change="archivoCambiado"
                          show-size
                          chips
                          accept="image/*"
                          prepend-icon="camera_alt"
                          placeholder="Seleccione una imagen"
                        >
                          <template v-slot:selection="{ text }">
                            <v-chip color="primary">
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>

                        <v-col cols="12" sm="6" md="4">
                          <v-autocomplete
                            outlined
                            dense
                            ref="pension"
                            v-model="pension"
                            :items="fondoPension"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="AFP"
                            item-text="descripcion"
                            item-value="id"
                            required
                          ></v-autocomplete>

                          <v-text-field
                            outlined
                            dense
                            ref="nua"
                            v-model="nua"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="NUA"
                            required
                          ></v-text-field>

                          <v-autocomplete
                            outlined
                            dense
                            ref="id_nit"
                            v-model="id_nit"
                            :items="nits"
                            :rules="[]"
                            label="Nit Facturación"
                            item-text="descripcion"
                            item-value="id"
                          ></v-autocomplete>
                          <v-btn
                            value="Agregar Nit"
                            @click="activarDialogNit()"
                          >
                            <span>Agregar Nit</span>
                            <v-icon color="green"> add_circle_outline </v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-spacer></v-spacer>
                          <v-spacer></v-spacer>
                          <v-autocomplete
                            outlined
                            dense
                            ref="subsidio"
                            v-model="subsidio"
                            :items="subsidios"
                            :rules="[]"
                            label="Recibe Subsidio Prenatal/lactancia"
                            item-text="descripcion"
                            item-value="id"
                          ></v-autocomplete>
                          <div v-show="subsidio == 'S'">
                            <v-autocomplete
                              outlined
                              dense
                              ref="cant_subsidio"
                              v-model="cant_subsidio"
                              :items="cant_subsidios"
                              :rules="[]"
                              :error-messages="errorMessagesPersona"
                              label="Cantidad de subsidios"
                            ></v-autocomplete>
                          </div>
                          <div
                            v-show="
                              cant_subsidio == '1' ||
                              cant_subsidio == '2' ||
                              cant_subsidio == '3'
                            "
                          >
                            <v-text-field
                              outlined
                              type="date"
                              dense
                              ref="fecha_subsidio_1"
                              v-model="fecha_subsidio_1"
                              :rules="[]"
                              :error-messages="errorMessagesPersona"
                              label="Fecha inicio Subsidio 1"
                            ></v-text-field>
                          </div>
                          <div
                            v-show="
                              cant_subsidio == '2' || cant_subsidio == '3'
                            "
                          >
                            <v-text-field
                              outlined
                              type="date"
                              dense
                              ref="fecha_subsidio_2"
                              v-model="fecha_subsidio_2"
                              :rules="[]"
                              :error-messages="errorMessagesPersona"
                              label="Fecha inicio Subsidio 2"
                            ></v-text-field>
                          </div>
                          <div v-show="cant_subsidio == '3'">
                            <v-text-field
                              outlined
                              type="date"
                              dense
                              ref="fecha_subsidio_3"
                              v-model="fecha_subsidio_3"
                              :rules="[]"
                              :error-messages="errorMessagesPersona"
                              label="Fecha inicio Subsidio 3"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            outlined
                            dense
                            ref="talla_camisa"
                            v-model="talla_camisa"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="Talla Camisa"
                            required
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            ref="talla_pantalon"
                            v-model="talla_pantalon"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="Talla Pantalón"
                            required
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            ref="talla_zapato"
                            v-model="talla_zapato"
                            :rules="[]"
                            :error-messages="errorMessagesPersona"
                            label="Talla Zapato"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item eager>
                    <v-card flat>
                      <v-card-text> </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item eager>
                    <v-card>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" sm="6" md="4">
                            <v-autocomplete
                              outlined
                              dense
                              ref="forma_pago"
                              v-model="forma_pago"
                              :items="formaPagos"
                              :rules="[]"
                              :error-messages="errorMessagesPersona"
                              label="Forma de Pago"
                              required
                            ></v-autocomplete>
                            <div v-show="forma_pago == 'Banco'">
                              <v-autocomplete
                                outlined
                                dense
                                ref="id_banco"
                                v-model="id_banco"
                                :items="bancos"
                                :rules="[]"
                                :error-messages="errorMessagesPersona"
                                item-text="descripcion"
                                item-value="id"
                                label="Banco para abono"
                                required
                              ></v-autocomplete>
                              <v-text-field
                                outlined
                                dense
                                ref="nro_cuenta"
                                v-model="nro_cuenta"
                                :rules="[rules.max45]"
                                :error-messages="errorMessagesPersona"
                                label="No. de Cuenta para abono"
                                required
                              ></v-text-field>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item eager>
                    <v-card>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" sm="6" md="4">
                            <v-radio-group
                              ref="aplica_seguro"
                              v-model="aplica_seguro"
                              label="¿Aplica caja de seguro?"
                              :rules="[]"
                              :error-messages="errorMessagesPersona"
                            >
                              <v-radio key="S" label="Si" value="S"></v-radio>
                              <v-radio key="N" label="No" value="N"></v-radio>
                            </v-radio-group>
                            <div v-show="aplica_seguro == 'S'">
                              <v-autocomplete
                                outlined
                                dense
                                ref="id_seguro"
                                v-model="id_seguro"
                                :items="seguros"
                                :rules="[]"
                                :error-messages="errorMessagesPersona"
                                item-text="descripcion"
                                item-value="id"
                                label="Seguro"
                                required
                              ></v-autocomplete>

                              <v-text-field
                                outlined
                                dense
                                ref="nro_asegurado"
                                v-model="nro_asegurado"
                                :rules="[]"
                                :error-messages="errorMessagesPersona"
                                label="No. de Asegurado"
                                required
                              ></v-text-field>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item eager>
                    <v-card>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" sm="6" md="4">
                            <v-radio-group
                              ref="tiene_discapacidad"
                              v-model="tiene_discapacidad"
                              label="¿Tiene discapacidad?"
                              :rules="[]"
                              :error-messages="errorMessagesPersona"
                            >
                              <v-radio key="S" label="Si" value="S"></v-radio>
                              <v-radio key="N" label="No" value="N"></v-radio>
                            </v-radio-group>
                            <v-radio-group
                              ref="tutor_discapacidad"
                              v-model="tutor_discapacidad"
                              label="¿Es tutor de persona con discapacidad?"
                              :rules="[]"
                              :error-messages="errorMessagesPersona"
                            >
                              <v-radio key="S" label="Si" value="S"></v-radio>
                              <v-radio key="N" label="No" value="N"></v-radio>
                            </v-radio-group>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogActivar" persistent max-width="290">
              <v-card>
                <div v-if="estado == 'A'">
                  <v-card-title class="headline"
                    >Desactivar Persona</v-card-title
                  >
                  <v-card-text
                    >Esta acción desactivará la Persona seleccionada ¿Desea
                    continuar?</v-card-text
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogActivar = false">Cancelar</v-btn>
                    <v-btn color="primary" text @click="desactivar()"
                      >Continuar</v-btn
                    >
                  </v-card-actions>
                </div>
                <div v-else>
                  <v-card-title class="headline">Activar Persona</v-card-title>
                  <v-card-text
                    >Esta acción activará la Persona seleccionada. ¿Desea
                    continuar?</v-card-text
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogActivar = false">Cancelar</v-btn>
                    <v-btn color="primary" text @click="activar()"
                      >Continuar</v-btn
                    >
                  </v-card-actions>
                </div>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogNit" max-width="500px">
              <v-card ref="form">
                <v-card-title>
                  <span class="headline">Agregar Nit</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <v-text-field
                          outlined
                          dense
                          ref="codigoNit"
                          v-model="codigoNit"
                          :rules="[rules.requerido, rules.min2, rules.max25]"
                          :error-messages="errorMessagesNit"
                          label="Nit"
                          placeholder="Nit"
                          required
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6" sm="6" md="6">
                        <v-text-field
                          outlined
                          dense
                          ref="descripcionNit"
                          v-model="descripcionNit"
                          :rules="[rules.requerido, rules.min2, rules.max100]"
                          :error-messages="errorMessagesNit"
                          label="Razón Social"
                          placeholder="Razón Social"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          dense
                          ref="notasNit"
                          v-model="notasNit"
                          :rules="[]"
                          :error-messages="errorMessagesNit"
                          label="Notas"
                          placeholder="Notas"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-text-field
                          outlined
                          dense
                          ref="primer_nombreNit"
                          v-model="primer_nombreNit"
                          :rules="[]"
                          :error-messages="errorMessagesNit"
                          label="Primer Nombre"
                          placeholder="Primer Nombre"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-text-field
                          outlined
                          dense
                          ref="segundo_nombreNit"
                          v-model="segundo_nombreNit"
                          :rules="[]"
                          :error-messages="errorMessagesNit"
                          label="Segundo Nombre"
                          placeholder="Segundo Nombre"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-text-field
                          outlined
                          dense
                          ref="primer_apellidoNit"
                          v-model="primer_apellidoNit"
                          :rules="[]"
                          :error-messages="errorMessagesNit"
                          label="Primer Apellido"
                          placeholder="Primer Apellido"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-text-field
                          outlined
                          dense
                          ref="segundo_apellidoNit"
                          v-model="segundo_apellidoNit"
                          :rules="[]"
                          :error-messages="errorMessagesNit"
                          label="Segundo Apellido"
                          placeholder="Segundo Apellido"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-text-field
                          outlined
                          dense
                          ref="direccionNit"
                          v-model="direccionNit"
                          :rules="[]"
                          :error-messages="errorMessagesNit"
                          label="Dirección"
                          placeholder="Dirección"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-text-field
                          outlined
                          dense
                          ref="correoNit"
                          v-model="correoNit"
                          :rules="[]"
                          :error-messages="errorMessagesNit"
                          label="Correo"
                          placeholder="Correo"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-text-field
                          outlined
                          dense
                          ref="telefonoNit"
                          v-model="telefonoNit"
                          :rules="[]"
                          :error-messages="errorMessagesNit"
                          label="Teléfono"
                          placeholder="Teléfono"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-text-field
                          outlined
                          dense
                          ref="celularNit"
                          v-model="celularNit"
                          :rules="[]"
                          :error-messages="errorMessagesNit"
                          label="Celular"
                          placeholder="Celular"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="closeNit">Cancelar</v-btn>
                  <v-btn color="primary" text @click="guardarNit"
                    >Guardar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogUpload" max-width="50%">
              <v-card>
                <v-card-title>
                  <span class="headline">Carga Masiva de Datos</span>
                </v-card-title>
                <v-card-text>
                  <v-file-input
                    dense
                    id="file"
                    ref="file"
                    v-model="file"
                    @change="archivoCambiado"
                    show-size
                    chips
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    prepend-icon="cancel_presentation"
                    placeholder="Seleccione un archivo Excel"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip color="primary">
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                  <v-spacer></v-spacer>
                  <div v-show="mostrarErrores">
                    <v-textarea
                      outlined
                      dense
                      ref="error"
                      v-model="error"
                      :rules="[]"
                      :readonly="true"
                      :error-messages="errorMessagesUpload"
                      label="Lista de Errores"
                      placeholder="Lista de Errores"
                      required
                    ></v-textarea>
                  </div>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="closeUpload"
                    >Cancelar</v-btn
                  >
                  <v-btn color="primary" text @click="guardarExcel"
                    >Guardar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog
              v-model="dialogRechazarPersona"
              persistent
              max-width="290"
            >
              <v-card>
                <v-card-title class="headline">¿Está seguro?</v-card-title>
                <v-card-text
                  >Esta acción rechazará la solicitud de personal seleccionada.
                  ¿Desea continuar?</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogRechazarPersona = false"
                    >Cancelar</v-btn
                  >
                  <v-btn color="primary" text @click="rechazarPersona()"
                    >Continuar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialogEliminarPersona"
              persistent
              max-width="290"
            >
              <v-card>
                <v-card-title class="headline">¿Está seguro?</v-card-title>
                <v-card-text
                  >Esta acción eliminará la solicitud de personal seleccionada.
                  ¿Desea continuar?</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogEliminarPersona = false"
                    >Cancelar</v-btn
                  >
                  <v-btn color="primary" text @click="eliminarPersona()"
                    >Continuar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogAprobarRH" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">¿Está seguro?</v-card-title>
                <v-card-text
                  >Esta acción aprobará la solicitud de personal para ser
                  auotrizada por instancias superiores. ¿Desea
                  continuar?</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogAprobarRH = false">Cancelar</v-btn>
                  <v-btn color="primary" text @click="aprobarRH()"
                    >Continuar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogAutorizar" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">¿Está seguro?</v-card-title>
                <v-card-text
                  >Esta acción autorizará la adición de personal eventual a la
                  planilla de Personas & Cultura. ¿Desea continuar?</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogAutorizar = false">Cancelar</v-btn>
                  <v-btn color="primary" text @click="autorizar()"
                    >Continuar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogRevertirRH" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">¿Está seguro?</v-card-title>
                <v-card-text
                  >Esta acción revertirá la aprobación de la solicitud de
                  personal. ¿Desea continuar?</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogRevertirRH = false">Cancelar</v-btn>
                  <v-btn color="primary" text @click="revertirRH()"
                    >Continuar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogRevertirAut" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">¿Está seguro?</v-card-title>
                <v-card-text
                  >Esta acción revertirá la autorización para el personal
                  eventual. ¿Desea continuar?</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogRevertirAut = false"
                    >Cancelar</v-btn
                  >
                  <v-btn color="primary" text @click="revertirAut()"
                    >Continuar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:no-data>
          No hay solicitudes de personal para mostrar
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      camera: "auto",
      result: null,
      showScanConfirmation: false,

      personas: [],
      gastos: [],

      cargos: [],
      grupos: [],

      areas: [],
      subareas: [],
      parentescos: [],
      paises: [],
      ciudades: [],
      ciudadesDir: [],
      bancos: [],
      seguros: [],

      nits: [],
      usuario: this.$store.state.usuario.user,
      rol: this.$store.state.usuario.rol,
      id_usuario: this.$store.state.usuario.idusuario,
      nombreUsuario: this.$store.state.usuario.nombre,
      

      tipoDocumento: ["Carnet Identidad", "Run", "CI de Extranjero", "Otro"],
      cant_subsidios: [0, 1, 2, 3],

      fondoPension: [
        { id: "AFPFUT", descripcion: "AFP FUTURO" },
        { id: "AFPPRE", descripcion: "AFP PREVISION" },
      ],
      subsidios: [
        { id: "S", descripcion: "SI" },
        { id: "N", descripcion: "NO" },
      ],
      tipoSangre: [
        "O NEGATIVO",
        "O POSITIVO",
        "A NEGATIVO",
        "A POSITIVO",
        "B NEGATIVO",
        "B POSITIVO",
        "AB NEGATIVO",
        "AB POSITIVO",
        "NO DETERMINADO",
      ],
      lugarEmision: [
        "La Paz",
        "Santa Cruz",
        "Cochabamba",
        "Potosí",
        "Oruro",
        "Chuquisaca",
        "Tarija",
        "Beni",
        "Pando",
        "Otro",
      ],
      formaPagos: ["Banco", "Efectivo", "Cheque"],

      generos: ["Masculino", "Femenino", "Otro"],
      estadoCiviles: ["Soltero", "Casado", "Otro"],
      actividadEconomicas: [
        "AGRICULTURA, PECUARIO, SILVICULTURA, CAZA Y PESCA",
        "PETRÓLEO CRUDO Y GAS NATURAL",
        "MINERALES METÁLICOS Y NO METÁLICOS",
        "INDUSTRIA DE ALIMENTOS",
        "OTRAS INDUSTRIAS",
        "ELECTRICIDAD, GAS Y AGUA",
        "CONSTRUCCIÓN",
        "COMERCIO",
        "TRANSPORTE Y ALMACENAMIENTO",
        "COMUNICACIONES",
        "SERVICIOS FINANCIEROS",
        "SERVICIOS A LAS EMPRESAS",
        "PROPIEDAD DE VIVIENDA",
        "SERVICIOS DE LA ADMINISTRACIÓN PÚBLICA",
        "IMPORTACIONES",
        "OTROS SERVICIOS",
      ],

      dialogPersona: false,
      dialogFoto: false,
      dialogUpload: false,
      dialogNit: false,
      dialogRechazar: false,
      dialogRechazarPersona: false,
      dialogEliminarPersona: false,
      dialogAprobarRH: false,
      dialogAutorizar: false,
      dialogRevertirRH: false,
      dialogRevertirAut: false,
      mostrarMensaje: false,
      menu: "",
      //
      page: 1,
      itemsPerPage: 12,

      headersPersona: [
        {
          text: "Opciones",
          value: "opciones",
          align: "left",
          sortable: false,
          width: "1%",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Código",
          value: "codigo",
          filter: this.filtroCodigo,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Nombre",
          value: "nombre_completo",
          filter: this.filtroNombre,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Area",
          value: "area",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Subarea",
          value: "subarea",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cargo",
          value: "cargo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Solicitante",
          value: "insertedBy",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Motivo",
          value: "motivo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Fecha Registro",
          value: "insertDate",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Fecha Ingreso",
          value: "fecha_ingreso",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Fecha Salida",
          value: "fecha_salida",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Estado",
          value: "estado",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
      ],

      rules: {
        requerido: (value) => !!value || "Debe llenar este campo.",
        numero: (value) => {
          const pattern = /^\d*\.?\d*$/;
          return pattern.test(value) || "Ingrese un número válido.";
        },
        GestionMin: (value) => value >= 1950 || "Ingrese una gestión superior.",
        GestionMax: (value) => value <= 2200 || "Ingrese una gestión inferior.",
        min2: (value) =>
          value.length >= 2 || "El campo tiene que tener mas de 2 caracteres.",
        min5: (value) =>
          value.length >= 5 || "El campo tiene que tener mas de 5 caracteres.",
        max10: (value) =>
          value.length <= 10 || "El campo debe tener menos de 10 caracteres.",
        max25: (value) =>
          value.length <= 25 || "El campo debe tener menos de 25 caracteres.",
        max30: (value) =>
          value.length <= 30 || "El campo debe tener menos de 30 caracteres.",
        max45: (value) =>
          value.length <= 45 || "El campo debe tener menos de 45 caracteres.",
        max50: (value) =>
          value.length <= 50 || "El campo debe tener menos de 50 caracteres.",
        max100: (value) =>
          value.length <= 100 || "El campo debe tener menos de 100 caracteres.",
        email: (value) => {
          const pattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/;
          return pattern.test(value) || "Ingrese un email válido.";
        },
      },

      search: "",
      searchNombreValue: "",
      searchCIValue: "",
      searchCodigoValue: "",

      editCodigo: false,
      mostrarNuevoCargo:false,
      editCodigo2: true,

      editedIndexPer: false,
      load: false,

      editedIndexCuc: false,

      editedIndexLnv: false,
      editedIndexDir: -1,
      editedIndexIns: -1,

      costoTotal: 0,

      id: "",

      id_parper: "",
      codigo: "PR01",
      doc_identidad: "5000000",
      apellido_1: "",
      emitido_en: "Santa Cruz",
      tipo_doc: "Carnet Identidad",
      aplica_afp: "S",
      es_jubilado: "",
      genero: "Otro",
      estado_civil: "Otro",
      tipo_sangre: "ND",
      id_pais: 30,
      id_pais_nac: 30,
      id_ciudad: 5090,
      viv_prop: "D",
      veh_prop: "D",
      dep_ini: "0",
      dep_prim: "0",
      dep_sec: "0",
      modo_sueldo: "MM",
      id_persona: "",
      nombre_1: "Eventual - ",
      nombres_2: "",
      nombres_3: "",

      apellido_2: "",
      apellido_3: "",
      foto: "",
      validaPersona: 0,
      validaPersona: 0,

      validaNit: 0,
      esPlanilla: false,

      codigoNit: "",
      descripcionNit: "",
      notasNit: "",
      primer_nombreNit: "",
      segundo_nombreNit: "",
      primer_apellidoNit: "",
      segundo_apellidoNit: "",
      direccionNit: "",
      correoNit: "",
      telefonoNit: "",
      celularNit: "",
      porcentaje: 0,
      nua: "",
      adCodigo: "",
      errorMessagesPersona: "",
      errorMessagesNit: "",
      errorMessagesUpload: "",

      nombreCompleto: "",

      adic_segip: "",
      solicitante: this.nombreUsuario,
      fechaSolicitud: this.fechaActual(),
      vence_doc: "",
      pension: "",

      fecha_nac: this.fechaActual(),
      fecha_ingreso: "",
      fecha_ingreso: "",
      fecha_ingreso_vac: "",
      fecha_ingreso_ant_vac: "",
      fecha_ingreso_bono_ant: "",
      fecha_salida: "",

      pasaporte: "",
      permiso_conducir: "",
      forma_pago: "",
      vence_permiso: "",
      id_nit: "",
      cant_subsidio: "0",
      fecha_subsidio_1: "",
      fecha_subsidio_2: "",
      fecha_subsidio_3: "",
      subsidio: "N",

      profesion: "",
      telefono_1: "",
      telefono_2: "",
      telefono_3: "",
      contacto_emer: "",
      telefono_emer: "",
      direccion: "",

      email_1: "",
      email_2: "",
      email_3: "",

      red_social_1: "",
      red_social_2: "",
      red_social_3: "",
      info_adicional: "",
      motivo: "",
      salario_ref: "",
      nro_cuenta: "",
      nro_asegurado: "",
      aplica_seguro: "",
      tiene_discapacidad: "",
      tutor_discapacidad: "",
      id_banco: "",
      id_seguro: "",
      porcentajeLnv: 0,

      talla_camisa: "",
      talla_pantalon: "",
      talla_zapato: "",

      tab: null,
      file: null,
      mostrarErrores: false,
      price: "",

      persona_cargo: "",
      id_cargo: "",
      id_codigo_cargo: "",
      id_grupo_nomina: "",
      nuevo_cargo: "",
      cargoAuxiliar: "",
      id_area: "",
      id_subarea: "",
      id_persona_cargo: "",
      cargo: "",
      grupo: "",
      observaciones: "",
      email: "",
      telefono1: "",
      telefono2: "",

      zona: "",
      calle: "",
      numero: "",
      edificio: "",
      piso: "",

      area: "",
      referencia: "",

      mostrarInactivos: false,
      mostrarOpcionesAprobacion: false,

      error: "",
      dialogActivar: false,
      dialogQR: false,
      estado: "S",
    };
  },

  computed: {
    formTitle() {
      return "Registro de: " + this.nombre_1 + " " + this.apellido_1;
    },

    formPersona() {
      return {
        codigo: this.codigo,
        nombre_1: this.nombre_1,
        nombres_2: this.nombres_2,
        nombres_3: this.nombres_3,
        apellido_1: this.apellido_1,
        apellido_2: this.apellido_2,
        apellido_3: this.apellido_3,
        fecha_nac: this.fecha_nac,
        id_pais_nac: this.id_pais_nac,
        id_ciudad: this.id_ciudad,
        doc_identidad: this.doc_identidad,
        emitido_en: this.emitido_en,
        tipo_doc: this.tipo_doc,
        adic_segip: this.adic_segip,
        pasaporte: this.pasaporte,
        vence_doc: this.vence_doc,
        genero: this.genero,
        estado_civil: this.estado_civil,
        id_pais: this.id_pais,
        permiso_conducir: this.permiso_conducir,
        vence_permiso: this.vence_permiso,
        tipo_sangre: this.tipo_sangre,
        telefono_emer: this.telefono_emer,
        direccion: this.direccion,
        contacto_emer: this.contacto_emer,
        telefono_1: this.telefono_1,
        telefono_2: this.telefono_2,
        email_1: this.email_1,
        email_2: this.email_2,
        red_social_1: this.red_social_1,
        red_social_2: this.red_social_2,
        red_social_3: this.red_social_3,
        dep_ini: this.dep_ini,
        dep_prim: this.dep_prim,
        dep_sec: this.dep_sec,
        profesion: this.profesion,
        fecha_ingreso: this.fecha_ingreso,
        fecha_ingreso_vac: this.fecha_ingreso_vac,
        fecha_ingreso_ant_vac: this.fecha_ingreso_ant_vac,
        fecha_ingreso_bono_ant: this.fecha_ingreso_bono_ant,
        id_area: this.id_area,
        id_subarea: this.id_subarea,
        id_cargo: this.id_cargo,
        id_grupo_nomina: this.id_grupo_nomina,
        nuevo_cargo: this.nuevo_cargo,
        telefono_3: this.telefono_3,
        email_3: this.email_3,
        fecha_salida: this.fecha_salida,
        info_adicional: this.info_adicional,
        motivo: this.motivo,
        salario_ref: this.salario_ref,
        id_nit: this.id_nit,
        cant_subsidio: this.cant_subsidio,
        fecha_subsidio_1: this.fecha_subsidio_1,
        fecha_subsidio_2: this.fecha_subsidio_2,
        fecha_subsidio_3: this.fecha_subsidio_3,
        subsidio: this.subsidio,
        talla_camisa: this.talla_camisa,
        talla_pantalon: this.talla_pantalon,
        talla_zapato: this.talla_zapato,
        forma_pago: this.forma_pago,
        id_banco: this.id_banco,
        nro_cuenta: this.nro_cuenta,
        pension: this.pension,
        nua: this.nua,
        aplica_seguro: this.aplica_seguro,
        id_seguro: this.id_seguro,
        nro_asegurado: this.nro_asegurado,
        tutor_discapacidad: this.tutor_discapacidad,
        tiene_discapacidad: this.tiene_discapacidad,
      };
    },

    formNit() {
      return {
        codigoNit: this.codigoNit,
        descripcionNit: this.descripcionNit,
        notasNit: this.notasNit,
        primer_nombreNit: this.primer_nombreNit,
        segundo_nombreNit: this.segundo_nombreNit,
        primer_apellidoNit: this.primer_apellidoNit,
        segundo_apellidoNit: this.segundo_apellidoNit,
        direccionNit: this.direccionNit,
        correoNit: this.correoNit,
        telefonoNit: this.telefonoNit,
        celularNit: this.celularNit,
      };
    },
  },

  watch: {
    dialogPersona(val) {
      val || this.closePersona();
    },

    dialogFoto(val) {
      val || this.closeFoto();
    },

    dialogPersona(val) {
      val || this.closePersona();
    },

    name() {
      this.errorMessagesPersona = "";

      this.errorMessagesNit = "";
      this.errorMessagesUpload = "";
    },
  },

  created() {
    this.listarPersona();
    this.selectPaises();
    this.selectCiudades();
    this.selectArea();
    this.selectBancos();
    this.selectSeguros();
    this.selectNits();
    
  },

  methods: {
    archivoCambiado(e) {
      this.selectedFile = e;
      if (e != null) {
        this.foto = URL.createObjectURL(this.selectedFile);
      } else {
        this.foto = "/uploads/loog_clwever.png";
      }
    },

    formatoFecha(fecha) {
      if (fecha == null) {
        return null;
      } else {
        if ((fecha != "") & (fecha != "0001-01-01T00:00:00")) {
          try {
            var m = new Date(fecha);
            var dateString =
              m.getUTCFullYear() +
              "-" +
              ("0" + (m.getUTCMonth() + 1)).slice(-2) +
              "-" +
              ("0" + m.getUTCDate()).slice(-2);
            return dateString;
          } catch (error) {
            console.error(error);
          }
        } else {
          return "";
        }
      }
    },

    fechaActual() {
      //var fecha = new Date();
      try {
        var m = new Date();
        var dateString =
          m.getUTCFullYear() +
          "-" +
          ("0" + (m.getUTCMonth() + 1)).slice(-2) +
          "-" +
          ("0" + m.getUTCDate()).slice(-2);
        return dateString;
      } catch (error) {
        console.error(error);
      }
    },
    //30/04/2071
    formatoFechaSpanish(fecha) {
      fecha = "30/04/2041";
      var anio = fecha.substring(6, 6);
      var mes = fecha.substring(3, 2);
      var dia = fecha.substring(0, 2);
      if (fecha != "") {
        try {
          var m = new Date(fecha);
          var dateString =
            m.getUTCFullYear() +
            "-" +
            ("0" + (m.getUTCMonth() + 1)).slice(-2) +
            "-" +
            ("0" + m.getUTCDate()).slice(-2);
          return dateString;
        } catch (error) {
          console.error(error);
        }
      } else {
        return "";
      }
    },

    listarPersona() {
      let me = this;

      axios
        .get("api/personas/ListarSolicitados/" + me.id_usuario)
        .then(function (response) {
          me.personas = response.data;
         
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
      me.mostrarInactivos = !me.mostrarInactivos;
    },
    mostrarGastos() {
      let me = this;
      var idCargo =
        me.id_cargo.id === undefined ||
        me.id_cargo.id === null ||
        me.id_cargo.id === ""
          ? 0
          : me.id_cargo.id;
      var idGrupoNomina =
        me.id_grupo_nomina === undefined ||
        me.id_grupo_nomina === null ||
        me.id_grupo_nomina === ""
          ? 0
          : me.id_grupo_nomina;

      axios
        .get(
          "api/presupuesto_lineas/gastoTotalPersonal/" +
            idCargo +
            "/" +
            idGrupoNomina +
            "/" +
            me.salario_ref
        )
        .then(function (response) {
          me.gastos = response.data;
         
          me.costoTotal = me.gastos.reduce(
            (sum, value) => sum + value.total,
            0
          );
          me.costoTotal = me.costoTotal.toFixed(2);
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },
    cargarNombre() {
      let me = this;
      this.selectGrupo();
      this.mostrarNuevoCargo = this.id_cargo.codigo.indexOf('NVO_')!==-1 || this.id_cargo.codigo.indexOf('EVT_')!==-1 || this.id_cargo.codigo.indexOf('PAS_')!==-1?true:false;
      //this.labelNuevoCargo = this.id_cargo.codigo.indexOf('NVO_')!==-1?"Nombre del nuevo Cargo":this.id_cargo.codigo.indexOf('EVT_')!==-1?"Nombre del Cargo Eventual":this.id_cargo.codigo.indexOf('PAS_')!==-1?"Nombre del Cargo de pasantía":"";
     
    
     
      this.apellido_1 = this.id_cargo.codigo.indexOf('NVO_')!==-1 || this.id_cargo.codigo.indexOf('EVT_')!==-1 || this.id_cargo.codigo.indexOf('PAS_')!==-1?this.nuevo_cargo:this.id_cargo.descripcion;
      
      this.salario_ref = this.id_cargo.salario_ref;
      this.mostrarGastos();
    },

    selectCargo() {
      let me = this;
      axios
        .get("api/cargos/filtrarSubarea/" + this.id_subarea)
        .then(function (response) {
          me.cargos = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    selectSubarea() {
      let me = this;
      axios
        .get(
          "api/subareas/SelectXUsuario/" + this.id_area + "/" + this.id_usuario
        )
        .then(function (response) {
          me.subareas = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    closePersona() {
      this.dialogPersona = false;
      this.limpiarPersona();
    },
    closeUpload() {
      this.dialogUpload = false;
      this.limpiarUpload();
    },

    closeNit() {
      this.dialogNit = false;
      this.limpiarNit();
    },

    closeQR() {
      this.dialogQR = false;
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/personas/cargarExcel/" + me.usuario, formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.closeUpload();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    limpiarNit() {
      this.codigoNit = "";
      this.descripcionNit = "";
      this.notasNit = "";
      this.primer_nombreNit = "";
      this.segundo_nombreNit = "";
      this.primer_apellidoNit = "";
      this.segundo_apellidoNit = "";
      this.direccionNit = "";
      this.correoNit = "";
      this.telefonoNit = "";
      this.celularNit = "";
      this.validaMensajeNit = [];
    },

    selectPaises() {
      let me = this;
      var paisesArray = [];
      axios
        .get("api/paises/select")
        .then(function (response) {
          paisesArray = response.data;
          paisesArray.map(function (x) {
            me.paises.push({ text: x.descripcion, value: x.id });
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    selectArea() {
      let me = this;
      axios
        .get("api/areas/selectXUsuario/" + me.id_usuario)
        .then(function (response) {

          me.areas = response.data;
          if (me.areas.length>0){
            me.id_area=me.id_area===""?me.areas[0].id:me.id_area;
            me.selectSubarea();
          }
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    selectGrupo() {
      let me = this;
      var codigoCargo=me.$esNulo(me.id_cargo.codigo)?me.cargoAuxiliar:me.id_cargo.codigo;
      
      axios
        .get("api/grupo_nominas/SelectNuevoPersonal/"+ codigoCargo)
        .then(function (response) {
          me.grupos = response.data;
          if(me.grupos.length===1){
            me.id_grupo_nomina=me.grupos[0].id;
            me.validarPeriodo();
          }
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },
    selectCiudades() {
      let me = this;
      axios
        .get("api/ciudades/filtrarPais/30")
        .then(function (response) {
          me.ciudades = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    selectBancos() {
      let me = this;
      axios
        .get("api/bancos/select")
        .then(function (response) {
          me.bancos = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },
    selectSeguros() {
      let me = this;
      axios
        .get("api/seguros/select")
        .then(function (response) {
          me.seguros = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    selectNits() {
      let me = this;
      axios
        .get("api/nits/select")
        .then(function (response) {
          me.nits = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    editItemPersona(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.nombre_1 = item.nombre_1;
      this.nombres_2 = item.nombres_2 === null ? "" : item.nombres_2;
      this.nombres_3 = item.nombres_3 === null ? "" : item.nombres_3;

      this.apellido_1 = item.apellido_1;
      this.apellido_2 = item.apellido_2 === null ? "" : item.apellido_2;
      this.apellido_3 = item.apellido_3 === null ? "" : item.apellido_3;

      this.solicitante = item.insertedBy;
      this.fechaSolicitud = this.formatoFecha(item.insertDate);

      this.tipo_doc = item.tipo_doc;
      this.adic_segip = item.adic_segip;
      this.tipo_doc = item.tipo_doc === null ? "" : item.tipo_doc;
      this.vence_doc = this.formatoFecha(item.vence_doc);
      this.adic_segip = item.adic_segip === null ? "" : item.adic_segip;
      this.pension = item.pension === null ? "" : item.pension;
      this.aplica_afp = item.aplica_afp === null ? "S" : item.aplica_afp;
      this.es_jubilado = item.es_jubilado === null ? "S" : item.es_jubilado;
      this.nua = item.nua === null ? "" : item.nua;
      this.doc_identidad =
        item.doc_identidad === null ? "" : item.doc_identidad;
      this.emitido_en = item.emitido_en;
      this.fecha_nac = this.formatoFecha(item.fecha_nac);
      this.fecha_ingreso = this.formatoFecha(item.fecha_ingreso);
      this.fecha_ingreso_vac = this.formatoFecha(item.fecha_ingreso_vac);
      this.fecha_ingreso_ant_vac = this.formatoFecha(
        item.fecha_ingreso_ant_vac
      );
      this.fecha_ingreso_bono_ant = this.formatoFecha(
        item.fecha_ingreso_bono_ant
      );
      this.fecha_salida = this.formatoFecha(item.fecha_salida);
      this.id_pais = item.id_pais;
      this.id_pais_nac = item.id_pais_nac;
      this.id_ciudad = item.id_ciudad;
      this.genero = item.genero;
      this.estado_civil = item.estado_civil;
      this.tipo_sangre = item.tipo_sangre;
      this.pasaporte = item.pasaporte;
      this.permiso_conducir = item.permiso_conducir;
      this.forma_pago = item.forma_pago;
      this.vence_permiso = this.formatoFecha(item.vence_permiso);

      this.id_nit = item.id_nit === null ? "" : item.id_nit;
      this.subsidio = item.subsidio === null ? "N" : item.subsidio;
      this.cant_subsidio =
        item.cant_subsidio === null ? "0" : item.cant_subsidio;
      this.fecha_subsidio_1 = this.formatoFecha(item.fecha_subsidio_1);
      this.fecha_subsidio_2 = this.formatoFecha(item.fecha_subsidio_2);
      this.fecha_subsidio_3 = this.formatoFecha(item.fecha_subsidio_3);

      this.id_cargo = item.id_cargo === null ? "" : item.id_cargo;
      this.cargoAuxiliar = item.cod_cargo;
      this.mostrarNuevoCargo=this.$esNulo(item.nuevo_cargo)?false:true;
      this.nuevo_cargo=item.nuevo_cargo;
      
      this.id_grupo_nomina =
        item.id_grupo_nomina === null ? "" : item.id_grupo_nomina;

      //this.rubro_empresa=item.rubro_empresa === null ? "":item.rubro_empresa;
      this.profesion = item.profesion === null ? "" : item.profesion;
      this.nro_cuenta = item.nro_cuenta === null ? "" : item.nro_cuenta;
      this.nro_asegurado =
        item.nro_asegurado === null ? "" : item.nro_asegurado;
      this.aplica_seguro =
        item.aplica_seguro === null ? "" : item.aplica_seguro;
      this.tiene_discapacidad =
        item.tiene_discapacidad === null ? "" : item.tiene_discapacidad;
      this.tutor_discapacidad =
        item.tutor_discapacidad === null ? "" : item.tutor_discapacidad;
      this.id_banco = item.id_banco === null ? "" : item.id_banco;
      this.id_area = item.id_area === null ? "" : item.id_area;
      this.id_subarea = item.id_subarea === null ? "" : item.id_subarea;
      this.id_seguro = item.id_seguro === null ? "" : item.id_seguro;
      this.talla_camisa = item.talla_camisa === null ? "" : item.talla_camisa;
      this.talla_pantalon =
        item.talla_pantalon === null ? "" : item.talla_pantalon;
      this.talla_zapato = item.talla_zapato === null ? "" : item.talla_zapato;
      //this.tipo_actividad=item.tipo_actividad === null ? "":item.tipo_actividad;
      this.info_adicional =
        item.info_adicional === null ? "" : item.info_adicional;
      this.motivo = item.motivo === null ? "" : item.motivo;
      this.salario_ref = item.salario_ref === null ? "0" : item.salario_ref;
      this.email_1 = item.email_1 === null ? "" : item.email_1;
      this.email_2 = item.email_2 === null ? "" : item.email_2;
      this.email_3 = item.email_3 === null ? "" : item.email_3;
      this.telefono_1 = item.telefono_1 === null ? "" : item.telefono_1;
      this.telefono_2 = item.telefono_2 === null ? "" : item.telefono_2;
      this.telefono_3 = item.telefono_3 === null ? "" : item.telefono_3;
      this.contacto_emer =
        item.contacto_emer === null ? "" : item.contacto_emer;
      this.telefono_emer =
        item.telefono_emer === null ? "" : item.telefono_emer;
      this.direccion = item.direccion === null ? "" : item.direccion;
      this.viv_prop = item.viv_prop === null ? "D" : item.viv_prop;
      this.modo_sueldo = item.modo_sueldo === null ? "MM" : item.modo_sueldo;
      this.veh_prop = item.veh_prop === null ? "D" : item.veh_prop;
      this.dep_ini =
        item.dep_ini === null ? "0" : item.dep_ini === 0 ? "0" : item.dep_ini;
      this.dep_prim =
        item.dep_prim === null
          ? "0"
          : item.dep_prim === 0
          ? "0"
          : item.dep_prim;
      this.dep_sec =
        item.dep_sec === null ? "0" : item.dep_sec === 0 ? "0" : item.dep_sec;
      this.red_social_1 = item.red_social_1 === null ? "" : item.red_social_1;
      this.red_social_2 = item.red_social_2 === null ? "" : item.red_social_2;
      this.red_social_3 = item.red_social_3 === null ? "" : item.red_social_3;

      this.foto = item.foto;
      this.editedIndexPer = true;
      this.dialogPersona = true;
      this.estado = item.estado;
      this.selectArea();
      this.selectSubarea();
      this.selectCargo();
      this.selectGrupo();

      this.editCodigo2 = true;
      this.editCodigo = false;
    },

    closePersona() {
      this.dialogPersona = false;
      this.limpiarPersona();
    },

    closeFoto() {
      this.dialogFoto = false;
    },

    limpiarPersona() {
      this.id = 0;
      this.codigo = "PR01";
      this.nombre_1 = "Eventual - ";
      this.nombres_2 = "";
      this.nombres_3 = "";
      this.apellido_1 = "";
      this.apellido_2 = "";
      this.apellido_3 = "";
      this.id_area = "";
      this.id_subarea = "";
      this.tipo_doc = "Carnet Identidad";
      this.adic_segip = "";
      this.solicitante = "";
      this.fechaSolicitud = "";
      this.nuevo_cargo = "";
      this.cargoAuxiliar = "";
      this.vence_doc = "";
      this.pension = "";
      this.es_jubilado = "";
      this.nua = "";
      this.doc_identidad = "5000000";
      this.emitido_en = "Santa Cruz";
      this.fecha_nac = this.fechaActual();
      this.fecha_salida = "";
      this.fecha_ingreso = "";
      this.fecha_ingreso_bono_ant = "";
      this.fecha_ingreso_ant_vac = "";
      this.fecha_ingreso_vac = "";
      this.id_pais = "30";
      this.id_pais_nac = "30";
      this.id_ciudad = "5090";
      this.dep_ini = "0";
      this.dep_sec = "0";
      this.dep_prim = "0";
      this.genero = "Otro";
      this.direccion = "";
      this.id_estado_civil = "Otro";
      this.tipo_sangre = "ND";
      this.pasaporte = "";
      this.permiso_conducir = "";
      this.forma_pago = "";
      this.vence_permiso = "";
      this.id_nit = "";
      (this.cant_subsidio = "0"),
        (this.fecha_subsidio_1 = ""),
        (this.fecha_subsidio_2 = ""),
        (this.fecha_subsidio_3 = ""),
        (this.subsidio = "N"),
        (this.id_cargo = "");
      this.id_grupo_nomina = "";
      this.profesion = "";
      this.id_banco = "";
      this.id_departamento = "";
      this.id_seguro = "";
      this.id_horario = "";
      this.id_plaza = "";
      this.id_ubicacion = "";
      this.id_estado_empleado = "";
      this.id_nomina = "";
      this.estado = "S";
      this.talla_camisa = "";
      this.talla_pantalon = "";
      this.talla_zapato = "";
      this.id_tipo_cuenta = "";
      this.nro_cuenta = "";
      this.nro_asegurado = "";
      this.aplica_seguro = "";
      this.tiene_discapacidad = "";
      this.tutor_discapacidad = "";
      this.info_adicional = "";
      this.motivo = "";
      this.salario_ref = "";

      this.email_1 = "";
      this.email_2 = "";
      this.email_3 = "";
      this.telefono_1 = "";
      this.telefono_2 = "";
      this.telefono_3 = "";
      this.telefono_emer = "";
      this.contacto_emer = "";

      this.red_social_1 = "";
      this.red_social_2 = "";
      this.red_social_3 = "";
      this.foto = "/uploads/loog_clwever.png";
      this.editedIndexPer = false;

      this.editCodigo2 = true;
      this.tab = 0;
    },

    exportarExcel() {
      let me = this;
      me.load = true;
      axios({
        url: "api/personas/ExportarExcelSolicitudesPersonal/"+ me.usuario,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "Reporte de Solicitudes de Personal - " + Date.now().toString() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        me.load = false;
      });
    },

    limpiarUpload() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },

    guardarPersona() {
      let me = this;
      //me.cargarNombre();
      
      if (this.validarPersona() > 0) {
     
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      const fechaActual = me.formatoFecha(new Date());
      /*
      if (fechaActual >= me.fecha_ingreso) {
        this.$store.dispatch("setSnackbar", {
          text: "La fecha de ingreso debe ser mayor a la fecha actual.",
          color: "error",
        });
        return;
      }
      */
      if (this.fecha_nac == null) {
        this.fecha_nac = "";
      }
      if (this.fecha_ingreso == null) {
        this.fecha_ingreso = "";
      }
      if (this.fecha_ingreso_vac == null) {
        this.fecha_ingreso_vac = "";
      }
      if (this.fecha_ingreso_ant_vac == null) {
        this.fecha_ingreso_ant_vac = "";
      }
      if (this.fecha_ingreso_bono_ant == null) {
        this.fecha_ingreso_bono_ant = "";
      }
      if (this.fecha_salida == null) {
        this.fecha_salida = "";
      }
      if (this.vence_doc == null) {
        this.vence_doc = "";
      }
      if (this.vence_permiso == null) {
        this.vence_permiso = "";
      }
      if (this.fecha_subsidio_1 == null) {
        this.fecha_subsidio_1 = "";
      }
      if (this.fecha_subsidio_2 == null) {
        this.fecha_subsidio_2 = "";
      }
      if (this.fecha_subsidio_3 == null) {
        this.fecha_subsidio_3 = "";
      }
      if (this.salario_ref == null || this.salario_ref == "") {
        this.salario_ref = "0";
      }

      if (this.editedIndexPer) {
        const formData = new FormData();
        formData.append("id", this.id);
        formData.append("codigo", this.codigo);
        formData.append("doc_identidad", this.doc_identidad);
        formData.append("tipo_doc", this.tipo_doc);
        formData.append("vence_doc", this.vence_doc);
        formData.append("adic_segip", this.adic_segip);
        formData.append("pension", this.pension);
        formData.append("aplica_afp", this.aplica_afp);
        formData.append("es_jubilado", this.es_jubilado);
        formData.append("nua", this.nua);
        formData.append("emitido_en", this.emitido_en);
        formData.append("apellido_1", this.apellido_1);
        formData.append("apellido_2", this.apellido_2);
        formData.append("apellido_3", this.apellido_3);
        formData.append("nombre_1", this.nombre_1);
        formData.append("nombres_2", this.nombres_2);
        formData.append("nombres_3", this.nombres_3);
        formData.append("fecha_nac", this.fecha_nac);
        formData.append("fecha_ingreso", this.fecha_ingreso);
        formData.append("fecha_ingreso_bono_ant", this.fecha_ingreso_bono_ant);
        formData.append("fecha_ingreso_ant_vac", this.fecha_ingreso_ant_vac);
        formData.append("fecha_ingreso_vac", this.fecha_ingreso_vac);
        formData.append("fecha_salida", this.fecha_salida);
        formData.append("id_pais", this.id_pais);
        formData.append("id_pais_nac", this.id_pais_nac);
        formData.append("id_ciudad", this.id_ciudad);
        formData.append("genero", this.genero);
        formData.append("estado_civil", this.estado_civil);
        formData.append("tipo_sangre", this.tipo_sangre);
        formData.append("pasaporte", this.pasaporte);
        formData.append("permiso_conducir", this.permiso_conducir);
        formData.append("forma_pago", this.forma_pago);
        formData.append("vence_permiso", this.vence_permiso);
        formData.append("id_nit", this.id_nit);
        formData.append("cant_subsidio", this.cant_subsidio);
        formData.append("fecha_subsidio_1", this.fecha_subsidio_1);
        formData.append("fecha_subsidio_2", this.fecha_subsidio_2);
        formData.append("fecha_subsidio_3", this.fecha_subsidio_3);
        formData.append("subsidio", this.subsidio);

        formData.append("id_cargo", this.id_cargo);
        formData.append("id_grupo_nomina", this.id_grupo_nomina);
        formData.append("nuevo_cargo", this.nuevo_cargo);
        formData.append("telefono_1", this.telefono_1);
        formData.append("telefono_2", this.telefono_2);
        formData.append("telefono_3", this.telefono_3);
        formData.append("contacto_emer", this.contacto_emer);
        formData.append("viv_prop", this.viv_prop);
        formData.append("veh_prop", this.veh_prop);
        formData.append("dep_ini", this.dep_ini);
        formData.append("dep_prim", this.dep_prim);
        formData.append("dep_sec", this.dep_sec);
        formData.append("telefono_emer", this.telefono_emer);
        formData.append("direccion", this.direccion);
        formData.append("email_1", this.email_1);
        formData.append("email_2", this.email_2);
        formData.append("email_3", this.email_3);
        formData.append("red_social_1", this.red_social_1);
        formData.append("red_social_2", this.red_social_2);
        formData.append("red_social_3", this.red_social_3);
        formData.append("profesion", this.profesion);
        formData.append("nro_cuenta", this.nro_cuenta);
        formData.append("nro_asegurado", this.nro_asegurado);
        formData.append("aplica_seguro", this.aplica_seguro);
        formData.append("tiene_discapacidad", this.tiene_discapacidad);
        formData.append("tutor_discapacidad", this.tutor_discapacidad);
        formData.append("id_banco", this.id_banco);
        formData.append("id_area", this.id_area);
        formData.append("id_seguro", this.id_seguro);
        formData.append("talla_camisa", this.talla_camisa);
        formData.append("talla_pantalon", this.talla_pantalon);
        formData.append("talla_zapato", this.talla_zapato);
        formData.append("info_adicional", this.info_adicional);
        formData.append("motivo", this.motivo);
        formData.append("salario_ref", this.salario_ref);
        formData.append("usuario", this.usuario);

        if (this.selectedFile != null) {
          formData.append(this.selectedFile.name, this.selectedFile);
        } else {
          formData.append(null, null);
        }

        axios
          .put("api/personas/actualizar", formData)
          .then(function (response) {
            me.closePersona();
            me.listarPersona();
            me.limpiarPersona();
            me.$store.dispatch("setSnackbar", {
              text: "Registro actualizado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
          });
      } else {
        let me = this;
        const formData = new FormData();
        formData.append("codigo", this.codigo);
        formData.append("doc_identidad", this.doc_identidad);
        formData.append("tipo_doc", this.tipo_doc);
        formData.append("adic_segip", this.adic_segip);
        formData.append("vence_doc", this.vence_doc);
        formData.append("pension", this.pension);
        formData.append("aplica_afp", this.aplica_afp);
        formData.append("es_jubilado", this.es_jubilado);
        formData.append("nua", this.nua);
        formData.append("emitido_en", this.emitido_en);
        formData.append("apellido_1", this.apellido_1);
        formData.append("apellido_2", this.apellido_2);
        formData.append("apellido_3", this.apellido_3);
        formData.append("nombre_1", this.nombre_1);
        formData.append("nombres_2", this.nombres_2);
        formData.append("nombres_3", this.nombres_3);
        formData.append("fecha_nac", this.fecha_nac);
        formData.append("fecha_ingreso", this.fecha_ingreso);
        formData.append("fecha_ingreso_bono_ant", this.fecha_ingreso_bono_ant);
        formData.append("fecha_ingreso_ant_vac", this.fecha_ingreso_ant_vac);
        formData.append("fecha_ingreso_vac", this.fecha_ingreso_vac);
        formData.append("fecha_salida", this.fecha_salida);
        formData.append("id_pais", this.id_pais);
        formData.append("id_pais_nac", this.id_pais_nac);
        formData.append("id_ciudad", this.id_ciudad);
        formData.append("genero", this.genero);
        formData.append("estado_civil", this.estado_civil);
        formData.append("tipo_sangre", this.tipo_sangre);
        formData.append("pasaporte", this.pasaporte);
        formData.append("permiso_conducir", this.permiso_conducir);
        formData.append("forma_pago", this.forma_pago);
        formData.append("vence_permiso", this.vence_permiso);
        formData.append("id_nit", this.id_nit);
        formData.append("cant_subsidio", this.cant_subsidio);
        formData.append("fecha_subsidio_1", this.fecha_subsidio_1);
        formData.append("fecha_subsidio_2", this.fecha_subsidio_2);
        formData.append("fecha_subsidio_3", this.fecha_subsidio_3);
        formData.append("subsidio", this.subsidio);
        formData.append("id_cargo", this.id_cargo.id);
        formData.append("id_grupo_nomina", this.id_grupo_nomina);
        formData.append("nuevo_cargo", this.nuevo_cargo);
        
        formData.append("telefono_1", this.telefono_1);
        formData.append("telefono_2", this.telefono_2);
        formData.append("telefono_3", this.telefono_3);
        formData.append("telefono_emer", this.telefono_emer);
        formData.append("direccion", this.direccion);
        formData.append("contacto_emer", this.contacto_emer);
        formData.append("viv_prop", this.viv_prop);
        formData.append("veh_prop", this.veh_prop);
        formData.append("dep_ini", this.dep_ini);
        formData.append("dep_prim", this.dep_prim);
        formData.append("dep_sec", this.dep_sec);
        formData.append("email_1", this.email_1);
        formData.append("email_2", this.email_2);
        formData.append("email_3", this.email_3);
        formData.append("red_social_1", this.red_social_1);
        formData.append("red_social_2", this.red_social_2);
        formData.append("red_social_3", this.red_social_3);
        formData.append("profesion", this.profesion);
        formData.append("nro_cuenta", this.nro_cuenta);
        formData.append("nro_asegurado", this.nro_asegurado);
        formData.append("aplica_seguro", this.aplica_seguro);
        formData.append("tiene_discapacidad", this.tiene_discapacidad);
        formData.append("tutor_discapacidad", this.tutor_discapacidad);
        formData.append("id_banco", this.id_banco);
        formData.append("id_area", this.id_area);
        formData.append("id_seguro", this.id_seguro);
        formData.append("talla_camisa", this.talla_camisa);
        formData.append("talla_pantalon", this.talla_pantalon);
        formData.append("talla_zapato", this.talla_zapato);
        formData.append("info_adicional", this.info_adicional);
        formData.append("motivo", this.motivo);
        formData.append("salario_ref", this.salario_ref);
        formData.append("usuario", this.usuario);

        if (this.selectedFile != null) {
          formData.append(this.selectedFile.name, this.selectedFile);
        } else {
          formData.append(null, null);
        }

        axios
          .post("api/personas/crear", formData)
          .then(function (response) {
            
            me.id = response.data;
            me.editedIndexPer = true;
            me.listarPersona();
            me.closePersona();
            me.$store.dispatch("setSnackbar", {
              text: "Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    guardarNit() {
      if (this.validarNit() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      let me = this;
      axios
        .post("api/nit/crear", {
          codigo: me.codigoNit,
          descripcion: me.descripcionNit,
          notas: me.notasNit,
          primer_nombre: me.primer_nombreNit,
          segundo_nombre: me.segundo_nombreNit,
          primer_apellido: me.primer_apellidoNit,
          segundo_apellido: me.segundo_apellidoNit,
          direccion: me.direccionNit,
          correo: me.correoNit,
          telefono: me.telefonoNit,
          celular: me.celularNit,
          v,
        })
        .then(function (response) {
          me.closeNit();
          me.limpiarNit();
          me.selectNits();
          me.$store.dispatch("setSnackbar", {
            text: "Nit creado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    addItem() {
      this.editCodigo = true;
      this.solicitante=this.nombreUsuario;
      this.fechaSolicitud=this.fechaActual();
      this.editCodigo2=false;
      this.dialogPersona = true;
    },

    mostrarCarga() {
      this.dialogUpload = true;
    },

    mostrarDialogRechazarPersona(item) {
      this.dialogRechazarPersona = true;
      this.id = item.id;
    },

    mostrarDialogAprobarRH() {
      this.dialogAprobarRH = true;
    },
    mostrarDialogAutorizar() {
      this.dialogAutorizar = true;
    },
    mostrarDialogRevertirRH() {
      this.dialogRevertirRH = true;
    },
    mostrarDialogRevertirAut() {
      this.dialogRevertirAut = true;
    },

    activarDialogPersona() {
      this.dialogPersona = true;
    },

    activarDialogNit() {
      this.dialogNit = true;
    },

    activarDialogQR() {
      this.dialogQR = true;
    },

    validarPersona() {
      this.validaPersona = 0;
      var elemento = "";
      var v = 0;
      var i = 0;
      var e = 0;

      Object.keys(this.formPersona).forEach((f) => {
        
  
        
        this.$refs[f].validate(true);
        e += 1;
        i++;
        if (this.$refs[f].validate(true)) {
          this.validaPersona += 0;
        } else {
          if (v == 0) {
            v = i;
            elemento = f;
          }
          this.validaPersona += 1;
          return;
        }
        
      });
      
     
      /*con este fragmento de codigo es posible direccionar el foco entre pestañas cuando se presentan errores de formulario
            if (v>0){
                this.tab=0;
                this.$refs[elemento].focus();
                if (v>33){
                    this.tab=1;
                    this.$refs[elemento].focus();
                    if (v>16){
                        this.tab=2;
                        this.$refs[elemento].focus();
                    }
                } 
            }
            */
      return this.validaPersona;
    },

    validarNit() {
      this.validaNit = 0;
      var i = 0;
      Object.keys(this.formNit).forEach((f) => {
        i += 1;
        
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.validaNit += 0;
        } else {
          this.validaNit += 1;
        }
      });
      return this.valida;
    },

    mostrarNombre() {
      this.nombreCompleto =
        this.nombre_1 +
        " " +
        this.nombres_2 +
        " " +
        this.nombres_3 +
        " " +
        this.apellido_1 +
        " " +
        this.apellido_2 +
        " " +
        this.apellido_3;
    },

    validarPeriodo() {
      let me = this;
      me.mostrarGastos();
      axios
        .get("api/grupo_nominas/esPlanilla/" + me.id_grupo_nomina)
        .then(function (response) {
          me.esPlanilla = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    mostrarCodigo() {
      if (this.editedIndexPer == false) {
        this.codigo = this.doc_identidad;
      }
    },

    activarDialog(item) {
      this.id = item.id;
      this.estado = item.estado;
      this.dialogActivar = true;
    },

    activar(item) {
      let me = this;
      axios
        .put("api/personas/activar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.dialogActivar = false;
          me.listarPersona();
          me.$store.dispatch("setSnackbar", {
            text: "Persona activada exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    desactivar(item) {
      let me = this;
      axios
        .put("api/personas/desactivar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.dialogActivar = false;
          me.listarPersona();
          me.$store.dispatch("setSnackbar", {
            text: "Persona desactivada exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },
    eliminarPersona() {
      let me = this;
      axios
        .put("api/personas/eliminar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.dialogActivar = false;

          me.listarPersona();
          me.closePersona();
          me.dialogEliminarPersona = false;
          me.$store.dispatch("setSnackbar", {
            text: "Solicitud de Personal eliminada exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    rechazarPersona() {
      let me = this;
      
      axios
        .put("api/personas/Rechazar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listarPersona();
          me.dialogRechazarPersona = false;
          me.dialogPersona = false;
          me.$store.dispatch("setSnackbar", {
            text: "Personal rechazado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    pendiente() {
      let me = this;
      axios
        .put("api/personas/Pendiente/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listarPersona();
          me.dialogPersona = false;
          me.$store.dispatch("setSnackbar", {
            text: "Personal marcado como solicitado.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },
    aprobarRH() {
      let me = this;
      if (this.salario_ref == 0) {
        this.$store.dispatch("setSnackbar", {
          text: "El Haber Básico debe ser distinto de 0.",
          color: "error",
        });
        return;
      }
      axios
        .put(
          "api/personas/AprobarRH/" +
            me.id +
            "/" +
            me.salario_ref +
            "/" +
            me.usuario,
          {}
        )
        .then(function (response) {
          me.adCodigo = "";
          me.listarPersona();
          me.dialogAprobarRH = false;
          me.dialogPersona = false;
          me.$store.dispatch("setSnackbar", {
            text: "Solicitud Aprobada exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },
    autorizar() {
      let me = this;
      if (this.salario_ref == 0) {
        this.$store.dispatch("setSnackbar", {
          text: "El Haber Básico debe ser distinto de 0.",
          color: "error",
        });
        return;
      }
      axios
        .put(
          "api/personas/autorizar/" +
            me.id +
            "/" +
            me.salario_ref +
            "/" +
            me.usuario,
          {}
        )
        .then(function (response) {
          me.adCodigo = "";
          me.listarPersona();
          me.dialogAutorizar = false;
          me.dialogPersona = false;
          me.$store.dispatch("setSnackbar", {
            text: "Personal Autorizado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },
    revertirRH() {
      let me = this;
      if (this.salario_ref == 0) {
        this.$store.dispatch("setSnackbar", {
          text: "El Haber Básico debe ser distinto de 0.",
          color: "error",
        });
        return;
      }
      axios
        .put("api/personas/RevertirRH/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listarPersona();
          me.dialogRevertirRH = false;
          me.dialogPersona = false;
          me.$store.dispatch("setSnackbar", {
            text: "Solicitud revertida exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },
    revertirAut() {
      let me = this;
      if (this.salario_ref == 0) {
        this.$store.dispatch("setSnackbar", {
          text: "El Haber Básico debe ser distinto de 0.",
          color: "error",
        });
        return;
      }
      axios
        .put(
          "api/personas/AprobarRH/" +
            me.id +
            "/" +
            me.salario_ref +
            "/" +
            me.usuario,
          {}
        )
        .then(function (response) {
          me.adCodigo = "";
          me.listarPersona();
          me.dialogRevertirAut = false;
          me.dialogPersona = false;
          me.$store.dispatch("setSnackbar", {
            text: "Solicitud revertida exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    filtroCI(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCIValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.searchCIValue.toLowerCase());
    },

    filtroCodigo(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCodigoValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.searchCodigoValue.toLowerCase());
    },

    filtroNombre(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchNombreValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.searchNombreValue.toLowerCase());
    },
  },
};
</script>
